@if (!hidden) {
	<div
		[@alertAnimationTrigger]="animationState"
		[attr.data-test-class]="'alert-' + type()"
		[class]="
			cn(
				className(),
				!isToastr() && 'opacity-100',
				isToastr() && 'mb-2',
				!emphasized() && !hasElevation() && 'shadow-border',
				emphasized() && !hasElevation() && 'shadow-none',
				emphasized() && type() === 'dialog--error' && '!bg-error-50',
				emphasized() &&
					type() === 'dialog--warning' &&
					'!bg-warning-50',
				emphasized() && type() === 'dialog--info' && '!bg-select-50',
				emphasized() &&
					type() === 'dialog--success' &&
					'!bg-success-25',
				hasElevation() && 'elevation-3',
				size() === 'base' && 'py-3 pl-1 pr-3',
				size() === 'small' && 'py-2 pl-0.5 pr-2'
			)
		"
		(@alertAnimationTrigger.done)="onAlertVisibilityChange()"
		class="relative flex w-full flex-col items-start rounded bg-white opacity-0 shadow-ui-100"
	>
		<div class="flex w-full items-start">
			<span
				[class]="
					cn(
						type() === 'dialog--error' &&
							'border-error-100 bg-error-100',
						type() === 'dialog--warning' &&
							'border-warning-100 bg-warning-100',
						type() === 'dialog--info' &&
							'border-select-100 bg-select-100',
						type() === 'dialog--success' &&
							'border-success-100 bg-success-100',
						emphasized() && '!left-0 !top-0 !h-full'
					)
				"
				class="absolute -left-px -top-px h-[calc(100%+2px)] w-1.5 rounded-l border"
			></span>
			<span
				[class]="
					cn(
						size() === 'base' && 'mt-0.5 max-h-6',
						size() === 'small' && 'mt-1 max-h-4'
					)
				"
				class="ml-3"
			>
				@switch (type()) {
					@case ('dialog--error') {
						<ng-container
							[ngTemplateOutlet]="alertIcon"
							[ngTemplateOutletContext]="{
								src: emphasized()
									? 'assets/icons/icon-cross-circle-solid.svg'
									: 'assets/icons/icon-cross-circle-open.svg',
								color: 'text-error-100',
							}"
						/>
					}
					@case ('dialog--warning') {
						<ng-container
							[ngTemplateOutlet]="alertIcon"
							[ngTemplateOutletContext]="{
								src: emphasized()
									? 'assets/icons/icon-exclamation-mark-triangle-solid.svg'
									: 'assets/icons/icon-exclamation-mark-triangle.svg',
								color: 'text-warning-100',
							}"
						/>
					}
					@case ('dialog--success') {
						<ng-container
							[ngTemplateOutlet]="alertIcon"
							[ngTemplateOutletContext]="{
								src: emphasized()
									? 'assets/icons/icon-checkmark-circle-solid.svg'
									: 'assets/icons/icon-checkmark-circle-open.svg',
								color: 'text-success-100',
							}"
						/>
					}
					@case ('dialog--info') {
						<ng-container
							[ngTemplateOutlet]="alertIcon"
							[ngTemplateOutletContext]="{
								src: emphasized()
									? 'assets/icons/icon-exclamation-mark-circle-solid.svg'
									: 'assets/icons/icon-exclamation-mark-circle.svg',
								color: 'text-select-100',
							}"
						/>
					}
				}
			</span>
			<span
				[class]="
					cn(
						size() === 'base' && 'pl-3',
						size() === 'small' && 'pl-2'
					)
				"
				class="grow"
			>
				@if (title()) {
					<span
						[class]="
							cn(
								size() === 'base' && 'text-xl',
								size() === 'small' && 'text-base'
							)
						"
						class="font-semibold"
						data-test-id="title"
					>
						{{ title() }}
					</span>
				}
				@if (content()) {
					<markdown
						[class]="
							cn(
								!title() && 'mt-0.5 block',
								size() === 'small' && 'text-sm'
							)
						"
						[data]="content()"
						class="block"
						data-test-id="content"
					/>
					@if (subContent()) {
						<markdown
							[class]="cn(size() === 'small' && 'text-sm')"
							[data]="subContent()"
							class="mt-2 block italic"
							data-test-id="sub-content"
						/>
					}
				} @else {
					<ng-content />
				}
			</span>
			@if (closeable()) {
				<button
					[class]="
						cn(
							size() === 'base' && 'max-h-6',
							size() === 'small' && 'max-h-4'
						)
					"
					(click)="remove()"
					aria-label="Close alert"
					class="mt-1 cursor-pointer pl-3"
					data-test-id="close-action"
					type="button"
				>
					<svg-icon
						[class]="
							cn(
								size() === 'base' && 'h-6 w-6',
								size() === 'small' && 'h-4 w-4'
							)
						"
						[src]="'assets/icons/icon-cross.svg'"
						class="inline-block"
					/>
				</button>
			}
		</div>
	</div>
}

<ng-template #alertIcon let-color="color" let-src="src">
	<svg-icon
		[class]="color"
		[ngClass]="
			cn(size() === 'base' && 'h-6 w-6', size() === 'small' && 'h-4 w-4')
		"
		[src]="src"
		class="inline-block"
	/>
</ng-template>
